import { create } from "zustand";

export interface vehicleItem {
  vehicleID: string;
  vehicleNumber: string;
  vehicleType: string;
  vehicleRegistrationNumber: string;
  modelName: string;
  modelId?: string | number;
  manufacturerName: string;
  manufacturerId?: string | number;
  vehicleColor: string;
  materialSource: string;
  status: string;
  fleetCategory?: string;
  branchId?: string;
  branchName?: string;
  branchLocation?: string;
  currentMileage?: number;
  dayDelivery?: string;
  requiredLicenseCode?: string;
  requiresPdp?: boolean;
  assignedDriverNumber?: string;
  assignedDriverName?: string;
  currentCaseNumber?: string;
  currentAllocationNumber?: string;
  currentAllocationStatus?: string;
  currentBodyRemovalNumber?: string;
  currentBodyRemovalStatus?: string;
}

interface VehicleState {
  vehicle: vehicleItem[];
  totalElements: number;
  statusCounts: Record<string, number>;
  selectedVehicle: vehicleItem | null;

  setVehicle: (data: any) => void;
  setSelectedVehicle: (item: vehicleItem) => void;
  clearSelectedVehicle: () => void;
}

export const useVehicleStore = create<VehicleState>((set) => ({
  vehicle: [],
  totalElements: 0,
  statusCounts: {},
  selectedVehicle: null,

  setVehicle: (data) =>
    set({
      vehicle: data?.vehicle || [],
      totalElements: data?.totalCount || 0,
      statusCounts: data?.statusCounts || {},
    }),

  setSelectedVehicle: (item) =>
    set({
      selectedVehicle: item,
    }),

  clearSelectedVehicle: () =>
    set({
      selectedVehicle: null,
    }),
}));
